import { OrganizationTeamResponseDto } from 'app/API';

export const updateTeamMemberCount = (
  teams: OrganizationTeamResponseDto[] | undefined,
  teamId: string,
  delta: number,
): OrganizationTeamResponseDto[] | undefined =>
  teams?.map((team) => (team.id === teamId ? { ...team, members: Math.max(team.members + delta, 0) } : team));
